export const MIN = 0;
export const MAX = 999999;

export enum DefaultDeviceWidth {
  Mobile = 480,
  Tablet = 768,
  Desktop = 1280
}

// String enums cannot be computed, so hard-coding the values
export enum MediaQuery {
  ModernMobile = '@media (min-width: 375px)',
  Tablet = '@media (min-width: 768px)',
  Desktop = '@media (min-width: 1280px)',
  TabletOnly = '@media (min-width: 768px) and (max-width: 1279px)'
}

enum Breakpoint {
  Tablet = DefaultDeviceWidth.Tablet,
  Desktop = DefaultDeviceWidth.Desktop
}

export default Breakpoint;
